import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Alert, AlertTitle } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import { AddCircleOutline } from '@material-ui/icons';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Box,
  Divider,
  Typography,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  makeStyles,
  Tooltip,
  Grid,
  DialogContentText,
  Button,
  InputBase,
  InputLabel,
  IconButton,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { isEqual, get, set, isEmpty } from '../../../../../utils/lodash';
import { Label } from '../../../../../components/common/Label';
import ErrorIcon from '@material-ui/icons/Error';

const useStyles = makeStyles((theme) => ({
  subRoot: {
    marginBottom: theme.spacing(4),
  },
  dialogWidth: {
    minWidth: '40%',
    maxWidth: '40%',
  },
  dialogContent: {
    padding: 'unset',
  },
  dialogContainer: {
    '& .MuiDialog-paper': {
      width: '100%',
    },
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    padding: 0,
  },
  displayFlexButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: theme.spacing(3),
  },
  leftPaddingDialog: {
    paddingLeft: theme.spacing(4),
  },
  rightPadding: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      paddingRight: theme.spacing(0.5),
    },
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(2, 3, 2),
  },
  cancelButton: {
    borderColor: 'black',
  },
  saveButton: {
    color: 'white',
    boxShadow: 'none',
  },
  alert: {
    justifyContent: 'center',
    width: 'auto',
    '&  .MuiSvgIcon-fontSizeInherit': {
      fontSize: 'xx-large',
    },
    '& .MuiAlert-message': {
      fontSize: theme.spacing(3),
    },
  },
  warning: {
    marginTop: theme.spacing(4),
  },
}));

const DeleteMode = (props) => {
  const { id, isDelete, deleteButtonClicked, handleIsDelete, deleteManufacturerName, module = 'mode', deleteStorageConfigurationClicked } = props;
  const classes = useStyles();

  let deleteText = `Are you sure you want to delete the operating modes for ${deleteManufacturerName} ?`;
  const warningText = `This will remove all battery configurations for this manufacturer. Existing projects will not be affected.`;
  if (isEqual(module, 'Battery Configuration')) {
    deleteText = `Are you sure you want to delete the ${deleteManufacturerName} ?`;
  }
  return (
    <Box className={classes.subRoot}>
      <Dialog
        open
        onClose={handleIsDelete}
        aria-labelledby="customized-dialog-title"
        classes={{ paper: classes.dialogWidth }}
        fullWidth
        maxWidth="xs"
        disableEscapeKeyDown
      >
        <DialogTitle id="customized-dialog-title">
          <Box className={classes.dialogTitle}>
            <b>{isEqual(module, 'Battery Configuration') ? 'Delete ' + module : 'Delete Operating Mode'}</b>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <FormControl fullWidth>
            <br />
            <Typography>{deleteText}</Typography>
            {!isEqual(module, 'Battery Configuration') &&
              <Typography>{warningText}</Typography>}
            <br />
          </FormControl>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={handleIsDelete}
            size="small"
            variant="outlined"
            color="default"
            className={classes.cancelButton}
          >
            {'Cancel'}
          </Button>
          <Button
            size="small"
            color="primary"
            variant="contained"
            className={classes.saveButton}
            onClick={isEqual(module, 'Battery Configuration') ? deleteStorageConfigurationClicked : deleteButtonClicked}
          >
            {'OK'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DeleteMode;
